import { render } from "./EventSkeleton.vue?vue&type=template&id=0b9d75d8&scoped=true"
const script = {}

import "./EventSkeleton.vue?vue&type=style&index=0&id=0b9d75d8&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0b9d75d8"]])

export default __exports__